export const isWebView = () => {
  const { navigator } = window;
  const { userAgent } = navigator;
  const normalizedUserAgent = userAgent.toLowerCase();
  const { standalone } = navigator;

  const isIos = /ip(ad|hone|od)/.test(normalizedUserAgent) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
  const isAndroid = /android/.test(normalizedUserAgent);
  const isSafari = /safari/.test(normalizedUserAgent);

  return (isAndroid && /; wv\)/.test(normalizedUserAgent)) || (isIos && !standalone && !isSafari);
};

export const isSafariBrowser = () => {
  let userAgentString = window.navigator.userAgent;
  userAgentString = userAgentString.toLowerCase();
  const isChrome = userAgentString.indexOf('chrome') > -1;
  let isSafari = userAgentString.indexOf('safari') > -1;

  // Chrome contains the safari user agent aswell so set to false
  if (isChrome && isSafari) isSafari = false;
  return isSafari;
};

export const isChromeBrowser = () => {
  let userAgentString = window.navigator.userAgent;
  userAgentString = userAgentString.toLowerCase();
  const isIOS = /iphone|ipad|ipod/.test(userAgentString);
  const isChrome = userAgentString.includes('chrome');

  return isChrome && !isIOS;
};

export const getAppStoreLink = () => {
  const userAgentString = window.navigator.userAgent.toLowerCase();
  const isAndroid = /android/.test(userAgentString);
  const isIOS = /ip(ad|hone|od)/.test(userAgentString) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);

  if (isAndroid) return process.env.REACT_APP_GOOGLE_APP_LINK;
  if (isIOS) return process.env.REACT_APP_IOS_APP_LINK;
  return process.env.REACT_APP_IOS_APP_LINK;
};

export default isWebView;
